import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosService } from '../../../../services/api'
import { createThunkName } from '../../../../utils/createThunkname'
import { POPUP_URLS } from '../../../../configs/api'
import {
  CreatePopupDto,
  DeletePopupDto,
  GetAllPopupsQueryParams,
  GetAllPopupsResponse,
  GetPopupByIdResponse,
  UpdatePopupDto,
  UpdatePopupOrderDto
} from './types'

const PREFIX = 'popup'

export const PopupService = {
  getAllPopupsAsyncThunk: createAsyncThunk(
    createThunkName(PREFIX, 'getAllPopups'),
    async (queryParams: GetAllPopupsQueryParams) => {
      try {
        const result = await AxiosService.get<GetAllPopupsResponse>(POPUP_URLS.getAllPopups, { params: queryParams })
        return result.data
      } catch (error) {
        throw error
      }
    }
  ),
  getPopupByIdAsyncThunk: createAsyncThunk(createThunkName(PREFIX, 'getPopupById'), async (popupId: string) => {
    try {
      const result = await AxiosService.get<GetPopupByIdResponse>(POPUP_URLS.getPopupById(popupId))
      return result.data
    } catch (error) {
      throw error
    }
  }),
  createPopupAsyncThunk: createAsyncThunk(createThunkName(PREFIX, 'createPopup'), async (dto: CreatePopupDto) => {
    try {
      await AxiosService.post(POPUP_URLS.createPopup, dto)
    } catch (error) {
      throw error
    }
  }),
  updatePopupAsyncThunk: createAsyncThunk(createThunkName(PREFIX, 'updatePopup'), async (dto: UpdatePopupDto) => {
    try {
      await AxiosService.put(POPUP_URLS.updatePopup, dto)
    } catch (error) {
      throw error
    }
  }),
  updatePopupOrderAsyncThunk: createAsyncThunk(
    createThunkName(PREFIX, 'updatePopupOrder'),
    async (dto: UpdatePopupOrderDto) => {
      try {
        await AxiosService.put(POPUP_URLS.updatePopupOrder, dto)
      } catch (error) {
        throw error
      }
    }
  ),
  deletePopupAsyncThunk: createAsyncThunk(createThunkName(PREFIX, 'deletePopup'), async (dto: DeletePopupDto) => {
    try {
      await AxiosService.post(POPUP_URLS.deletePopup, dto)
    } catch (error) {
      throw error
    }
  })
}
